import Styles from './styles.module.css';
import React, { useEffect, useRef, useState } from 'react';
import { PhotoRow } from '../../types';
import { hardDelete } from '../../postActions';
import { formatDate } from '../../dateUtil';
import ConfirmDialog from '../../confirm/index';
import { BsThreeDots } from 'react-icons/bs';
import WaitImg from '../../../../../../image/default/wait.png';

type PhotoCardProps = {
  row: PhotoRow;
  staffName: string;
  time: number;
  onClick: () => void;
};

const MAX_VISIBLE_TAGS = 3;

const PhotoCard: React.FC<PhotoCardProps> = ({ row, staffName, time, onClick }) => {

  const [ menuOpen, setMenuOpen ] = useState(false);
  const [ confirmDelete, setConfirmDelete ] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [menuOpen]);

  function toggleMenu(e: React.MouseEvent) {
    e.stopPropagation();
    setMenuOpen((v) => !v);
  }

  async function handleConfirmDelete() {
    try {
      await hardDelete(row.id);
    } catch (error) {
      console.error('delete failed:', error);
    } finally {
      setConfirmDelete(false);
    }
  }

  const visibleTags = row.post_tags.slice(0, MAX_VISIBLE_TAGS);
  const restCount = row.post_tags.length - visibleTags.length;

  const imageUrl = `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/image%2Fresize_images%2F${row.id}_500x500?alt=media&token=?${time}`;

  return (
    <>
    <div className={Styles.card} onClick={onClick}>

      <div className={Styles.imageWrap}>
        <img
          className={Styles.image}
          src={imageUrl}
          alt=""
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = WaitImg; }}
        />

        <div className={Styles.menuWrap} ref={menuRef}>
          <button type="button" className={Styles.menuButton} onClick={toggleMenu}>
            <BsThreeDots className={Styles.menuIcon} />
          </button>
          {menuOpen && (
            <div className={Styles.menu} onClick={(e) => e.stopPropagation()}>
              <p className={Styles.menuDanger} onClick={(e) => { e.stopPropagation(); setMenuOpen(false); setConfirmDelete(true); }}>削除</p>
            </div>
          )}
        </div>
      </div>

      <div className={Styles.info}>
        {visibleTags.length > 0 && (
          <div className={Styles.tags}>
            {visibleTags.map((tag) => <span className={Styles.chip} key={tag}>{tag}</span>)}
            {restCount > 0 && <span className={Styles.chipMore}>+{restCount}</span>}
          </div>
        )}
        {row.post_title && <p className={Styles.title}>{row.post_title}</p>}
        <div className={Styles.metaRow}>
          {staffName && <span className={Styles.staff}>{staffName}</span>}
          <span className={Styles.date}>{formatDate(row.post_time)}</span>
        </div>
      </div>
    </div>

    {confirmDelete && (
      <ConfirmDialog
        title="この作品を削除しますか？"
        desc="この操作は取り消せません。作品データは完全に削除されます。"
        confirmLabel="削除する"
        danger
        onConfirm={handleConfirmDelete}
        onCancel={() => setConfirmDelete(false)}
      />
    )}
    </>
  );
}

export default PhotoCard;
